import { Card, CardBody, Col, Row } from "reactstrap";
import BorderedCheckbox from "./BorderedCheckbox";
import FilledCheckbox from "./FilledCheckbox";
import IconCheckbox from "./IconCheckbox";
import { CustomCheckboxTitle } from "../../../../../../constants";
import { CustomCheckBoxSubTitle } from "../../../../../../data/formsAndTable/forms/FormControls";
import CommonCardHeader from "../../../../../../coreComponents/CommonCardHeader";

const CustomCheckbox = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={CustomCheckboxTitle} span={CustomCheckBoxSubTitle} />
        <CardBody>
          <Row className="g-3">
            <BorderedCheckbox />
            <IconCheckbox />
            <FilledCheckbox />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default CustomCheckbox;
